import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react';

import { FontIcon, type FontIconName } from '../FontIcon';
import './Input.styl';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  invalid?: boolean;
  mono?: boolean;
  trailing?: ReactNode;
  leading?: ReactNode;
  /** Shorthand for a leading IcoMoon glyph. */
  icon?: FontIconName;
};

export const Input = forwardRef<HTMLInputElement, Props>(function Input(
  { invalid = false, mono = false, trailing, leading, icon, className, ...rest },
  ref
) {
  const classes = ['a-input'];
  if (invalid) classes.push('a-input--invalid');
  if (mono) classes.push('u-mono');
  if (className) classes.push(className);
  const input = <input ref={ref} className={classes.join(' ')} aria-invalid={invalid || undefined} {...rest} />;
  const lead = leading ?? (icon ? <FontIcon name={icon} /> : null);
  if (!trailing && !lead) return input;
  const wrap = ['a-input__wrap'];
  if (invalid) wrap.push('a-input__wrap--invalid');
  if (rest.disabled) wrap.push('a-input__wrap--disabled');
  return (
    <span className={wrap.join(' ')}>
      {lead ? <span className="a-input__slot">{lead}</span> : null}
      {input}
      {trailing ? <span className="a-input__slot">{trailing}</span> : null}
    </span>
  );
});
